module.exports = __webpack_public_path__ + "img/3.c431a01.jpg";